import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useSiteAdminAuth } from '@shared/providers/SiteAdminAuthContext';
import { getSiteAdminTheme } from '@shared/providers/admin-theme/configs';
import { DashboardCard } from '@/components/molecules';

/**
 * Site Admin Dashboard Component
 *
 * Displayed site name is taken directly from URL param `:site`. site = 'super-admin'
 * displays the English label "Super Admin".
 */
export const SiteAdminDashboard: React.FC = () => {
  const { admin } = useSiteAdminAuth();
  const { site } = useParams<{ site: string }>();

  const siteDisplayName = useMemo(() => {
    if (!site) return '';
    if (site === 'super-admin') return 'Super Admin';
    return (getSiteAdminTheme(site).siteName || '').replace(' 管理ポータル', '');
  }, [site]);

  return (
    <div>
      <h2 className="mb-6 text-2xl font-bold">
        {siteDisplayName} 管理ダッシュボード
        {admin?.name && <span className="ml-2 text-lg text-gray-500">- {admin.name}</span>}
      </h2>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
        <DashboardCard title="登録治療院数" value="42" color="blue" />
        <DashboardCard title="施術師数" value="128" color="green" />
        <DashboardCard title="本日のログイン" value="23" color="yellow" />
        <DashboardCard title="未読お知らせ" value="3" color="red" />
      </div>
    </div>
  );
};
